// All middle columns are plain editable text fields
const editableFields = [
    'applicationRole',
    'accountStore',
    'empowerIDName',
    'empowerIDDescription',
    'empowerIDText',
    'highLevelClassification',
    'processAttributesToAdd',
    'processAttributesToRemove',
    'differentiationValueToAdd',
    'differentiationValueToRemove',
    'ownersToAdd',
    'ownersToRemove',
    'approversToAdd',
    'approversToRemove',
    'publishInASP',
    'comments',
]

export const isEditable = (fieldName) => editableFields.includes(fieldName)

const getEditableConfig = (fieldName) => {
    if (!isEditable(fieldName)) return undefined
    return { type: 'text', placeholder: '' }
}

const colStyles = {
    color: '#282828',
    fontSize: '13px',
    minWidth: '150px',
}

const wideColStyles = {
    ...colStyles,
    minWidth: '180px',
}

const attributes = [
    // ── Frozen left ────────────────────────────────────────────────────────────
    {
        sticky: 'start',
        name: 'landscapeFriendlyName',
        sortable: true,
        sortBy: 'landscapeFriendlyName',
        label: 'Landscape',
        isEditable: false,
        hideValue: true,
        component: {
            componentName: 'Landscape',
            props: {
                statusIdProp: 'rtA_CSVInboxLandscapeStatusID',
            },
        },
        styles: {
            width: '120px',
            color: '#282828',
            fontSize: '13px',
        },
    },

    // ── Scrollable columns (all editable text) ─────────────────────────────────
    {
        name: 'applicationRole',
        sortable: true,
        sortBy: 'applicationRole',
        label: 'ApplicationRole',
        isEditable: isEditable('applicationRole'),
        editableConfig: getEditableConfig('applicationRole'),
        styles: wideColStyles,
    },
    {
        name: 'accountStore',
        sortable: true,
        sortBy: 'accountStore',
        label: 'AccountStore',
        isEditable: isEditable('accountStore'),
        editableConfig: getEditableConfig('accountStore'),
        styles: wideColStyles,
    },
    {
        name: 'empowerIDName',
        sortable: true,
        sortBy: 'empowerIDName',
        label: 'EmpowerIDName',
        isEditable: isEditable('empowerIDName'),
        editableConfig: getEditableConfig('empowerIDName'),
        styles: colStyles,
    },
    {
        name: 'empowerIDDescription',
        sortable: true,
        sortBy: 'empowerIDDescription',
        label: 'EmpowerIDDescription',
        isEditable: isEditable('empowerIDDescription'),
        editableConfig: getEditableConfig('empowerIDDescription'),
        styles: wideColStyles,
    },
    {
        name: 'empowerIDText',
        sortable: true,
        sortBy: 'empowerIDText',
        label: 'EmpowerIDText',
        isEditable: isEditable('empowerIDText'),
        editableConfig: getEditableConfig('empowerIDText'),
        styles: colStyles,
    },
    {
        name: 'highLevelClassification',
        sortable: true,
        sortBy: 'highLevelClassification',
        label: 'HighLevelClassification',
        isEditable: isEditable('highLevelClassification'),
        editableConfig: getEditableConfig('highLevelClassification'),
        styles: wideColStyles,
    },
    {
        name: 'processAttributesToAdd',
        sortable: true,
        sortBy: 'processAttributesToAdd',
        label: 'ProcessAttributesToAdd',
        isEditable: isEditable('processAttributesToAdd'),
        editableConfig: getEditableConfig('processAttributesToAdd'),
        styles: wideColStyles,
    },
    {
        name: 'processAttributesToRemove',
        sortable: true,
        sortBy: 'processAttributesToRemove',
        label: 'ProcessAttributesToRemove',
        isEditable: isEditable('processAttributesToRemove'),
        editableConfig: getEditableConfig('processAttributesToRemove'),
        styles: wideColStyles,
    },
    {
        name: 'differentiationValueToAdd',
        sortable: true,
        sortBy: 'differentiationValueToAdd',
        label: 'DifferentiationValueToAdd',
        isEditable: isEditable('differentiationValueToAdd'),
        editableConfig: getEditableConfig('differentiationValueToAdd'),
        styles: wideColStyles,
    },
    {
        name: 'differentiationValueToRemove',
        sortable: true,
        sortBy: 'differentiationValueToRemove',
        label: 'DifferentiationValueToRemove',
        isEditable: isEditable('differentiationValueToRemove'),
        editableConfig: getEditableConfig('differentiationValueToRemove'),
        styles: wideColStyles,
    },
    {
        name: 'ownersToAdd',
        sortable: true,
        sortBy: 'ownersToAdd',
        label: 'OwnersToAdd',
        isEditable: isEditable('ownersToAdd'),
        editableConfig: getEditableConfig('ownersToAdd'),
        styles: colStyles,
    },
    {
        name: 'ownersToRemove',
        sortable: true,
        sortBy: 'ownersToRemove',
        label: 'OwnersToRemove',
        isEditable: isEditable('ownersToRemove'),
        editableConfig: getEditableConfig('ownersToRemove'),
        styles: colStyles,
    },
    {
        name: 'approversToAdd',
        sortable: true,
        sortBy: 'approversToAdd',
        label: 'ApproversToAdd',
        isEditable: isEditable('approversToAdd'),
        editableConfig: getEditableConfig('approversToAdd'),
        styles: colStyles,
    },
    {
        name: 'approversToRemove',
        sortable: true,
        sortBy: 'approversToRemove',
        label: 'ApproversToRemove',
        isEditable: isEditable('approversToRemove'),
        editableConfig: getEditableConfig('approversToRemove'),
        styles: colStyles,
    },
    {
        name: 'publishInASP',
        sortable: true,
        sortBy: 'publishInASP',
        label: 'PublishInASP',
        isEditable: isEditable('publishInASP'),
        editableConfig: getEditableConfig('publishInASP'),
        styles: colStyles,
    },
    {
        name: 'comments',
        sortable: true,
        sortBy: 'comments',
        label: 'Comments',
        isEditable: isEditable('comments'),
        editableConfig: getEditableConfig('comments'),
        styles: wideColStyles,
    },

    // ── Frozen right ───────────────────────────────────────────────────────────
    {
        name: 'rtA_CSVInboxItemStatusName',
        sortable: true,
        sortBy: 'rtA_CSVInboxItemStatusName',
        label: 'Status',
        isEditable: false,
        hideValue: true,
        component: {
            componentName: 'InboxStatusIndicator',
            props: {
                dropdownOptionsMap: {
                    Invalid: ['Ignored'],
                    Ignored: ['Invalid'],
                },
                tooltipProp: 'rtA_CSVInboxItemStatusDescription',
                statusChangeConfig: {
                    itemIdProp: 'rtA_GroupAttributesID',
                    itemIdPayloadKey: 'rtA_GroupAttributesID',
                    statusIdPayloadKey: 'rtA_CSVInboxItemStatusID',
                    statusIdMap: {
                        'Not Validated': 1,
                        Valid: 2,
                        Invalid: 3,
                        Ignored: 4,
                        Completed: 5,
                        Error: 6,
                        'Publish Queued': 7,
                        Publishing: 8,
                    },
                },
            },
        },
        sticky: 'end',
        styles: { width: '180px' },
    },
    {
        sticky: 'end',
        styles: { width: '80px' },
        hideValue: true,
        button: { name: 'ShowHideButton' },
    },
]

export default attributes
